import { checkBrowser } from '@/lib/index';

/**
 * 인터파크 예매/취소 팝업을 열고, POST 데이터로 제출하는 함수
 * @param {Object} param0
 * @param {Object} param0.http - axios나 http 요청 객체
 * @param {'ticketing'|'confirmation'} type - 처리 타입 ('ticketing': 예매, 'confirmation': 취소)
 * @param {string} productCode - 상품 코드
 * @returns {Promise<void>}
 */
export async function ticketingFunc({ http }, type, productCode) {
  // 팝업 먼저 열기
  const win = window.open(
    '',
    type === 'ticketing' ? "wndBooking" : "wndCancel",
    "top=10, left=10, width=900, height=682, scrollbars=no"
  );

  if (win === null) {
    alert("팝업창이 제한되어 있어서 예매창을 열 수 없습니다.");
    return;
  }

  try {
    // 브라우저 체크 및 필요한 데이터 로드
    let browser = checkBrowser() ? 'mobile' : 'pc';
    const { data } = await http.get(`/interpark/${browser}/ticketing_info?product_code=${productCode}`);

    if (data.success) {
      const confirmationUrl = data.data.confirmation.url;
      const ticketingUrl = data.data.ticketing.url;

      const confirmation = data.data.confirmation;
      const ticketing = data.data.ticketing;

      const typeData = type === 'ticketing' ? ticketing : confirmation;
      const formAction = type === 'ticketing' ? ticketingUrl : confirmationUrl;

      // 팝업 내부에 직접 양식을 생성하고 제출
      win.document.open();
      win.document.write(`
        <html>
          <body>
            <form id="form" method="post" action="${formAction}" target="${type === 'ticketing' ? "wndBooking" : "wndCancel"}">
      `);

      Object.entries(typeData).forEach(([key, value]) => {
        win.document.write(`<input type="hidden" name="${key}" value="${String(value)}">`);
      });

      win.document.write(`
            </form>
            <script type="text/javascript">
              document.getElementById("form").submit();
            </script>
          </body>
        </html>
      `);
      win.document.close();
      win.focus();
    }
  } catch (err) {
    console.error(err);
  }
}
